import { render, staticRenderFns } from "./GuidePage.vue?vue&type=template&id=c18c7a0a&scoped=true"
import script from "./GuidePage.vue?vue&type=script&lang=js"
export * from "./GuidePage.vue?vue&type=script&lang=js"
import style0 from "./GuidePage.vue?vue&type=style&index=0&id=c18c7a0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18c7a0a",
  null
  
)

export default component.exports